import { api } from "../common/http";

const TenantInvitationsApi = {
  listActive: async ({ page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const res = await api.get("/tenant/invitations/active", { params: { page, size, sort } });
    return res.data;
  },
};

export default TenantInvitationsApi;
